export var timeStampInSecs = function () { return Math.round(Date.now() / 1000); };
export var timeout = function (milliseconds, message) {
    return new Promise(function (_, reject) {
        setTimeout(function () { return reject(new Error(message)); }, milliseconds);
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var get = function (key) {
    var value = localStorage.getItem(key);
    if (!value)
        return undefined;
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return undefined;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
var set = function (key, value) {
    try {
        var serialized = JSON.stringify(value);
        localStorage.setItem(key, serialized);
    }
    catch (e) {
        // ignore...
    }
};
var remove = function (key) {
    try {
        localStorage.removeItem(key);
    }
    catch (e) {
        // ignore...
    }
};
export var storage = {
    set: set,
    get: get,
    remove: remove,
};
//# sourceMappingURL=index.js.map